'use client'

import { useShoppingCart } from 'use-shopping-cart'
import { loadStripe } from '@stripe/stripe-js'
import { getAccessToken } from '@/app/lib/actions'

export default function CheckoutButton() {
  const { cartCount = 0, cartDetails, clearCart } = useShoppingCart()

  const redirectToCheckout = async () => {
    const pk = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY
    const apiHost = process.env.NEXT_PUBLIC_API_HOST
    
    if (!pk || !apiHost) {
      console.error('⚠️ Configuração do Stripe ou API faltando!')
      return
    }

    const stripe = await loadStripe(pk)

    if (!stripe) {
      console.error('❌ Stripe não foi inicializado corretamente.')
      return
    }

    const accessToken = await getAccessToken()

    // ✅ Transformar os dados do carrinho para o backend
    const lineItems = Object.entries(cartDetails ?? {}).map(([key, item]) => ({
      id: item.id,
      name: item.name || item.title || 'Ticket',
      price: Math.round(item.price * 100), // ✔️ Converter para centavos
      quantity: item.quantity ?? 1, // ✔️ Garante que sempre tenha quantidade
    }))

    if (lineItems.length === 0) {
      alert('Seu carrinho está vazio.')
      return
    }

    try {
      console.log('🛒 Dados enviados para o backend:', lineItems);
      const response = await fetch(`${apiHost}/api/shops/tickets/checkout/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ cartDetails: lineItems }),
      })

      const data = await response.json()

      if (!response.ok || !data.sessionId) {
        console.error('❌ Erro no backend:', data)
        alert('Houve um erro ao iniciar o pagamento. Você fez login?')
        return
      }

      const { error } = await stripe.redirectToCheckout({
        sessionId: data.sessionId,
      })

      if (error) {
        console.error('❌ Erro no redirecionamento:', error.message)
      } else {
        clearCart();
      }
    } catch (error) {
      console.error('❌ Erro no processo de checkout:', error)
    }
  }

  return (
    <button
      onClick={() => {
        if (cartCount > 0) redirectToCheckout()
      }}
      disabled={cartCount === 0}
      className="w-full py-2 px-4 border border-transparent bg-sky-900 text-white hover:opacity-90 disabled:opacity-50"
    >
      Pagar agora
    </button>
  )
}
